<template>
    <v-data-table
        dense
        :headers="headers"
        :items="data"
        :data="loading"
        :loading="loading"
        :server-items-length="length"
        :options="options"
        @update:options="updateOptions"
        :footer-props="footer"
        >
        <template v-slot:[`item.code`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.purchase_order.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.code}}
        </template>

        <template v-slot:[`item.state`]="{item}">
            <PStatus :state="item.state"/>
        </template>
    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex';
import PStatus from './../common/PStatus';

export default {
    name: "PurchaseOrderList",
    components: {
        PStatus
    },
    props: {
        data: Array
    },
    data() {
        return {
            footer: {
                'items-per-page-options': [10, 25, 50]
            },
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Supplier", value: "supplier" },
                { text: "Currency", value: "currency" },
                { text: "State", value: "state" },
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            options: "purchase/order/options",
            loading: "purchase/order/loading",
            length: "purchase/order/length",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "purchase/order/updateOptions"
        }),
        handleClickRow(item) {
            this.$router.push({name: "PurchaseOrderDisplay", params: {id: item.id}})
        }
    }
}
</script>

<style>

</style>